export default "__VITE_ASSET__7c0a302c__"